import React from "react";
import { Platform, ScrollView, View } from "react-native";
import { useIsMobile } from "utils/hooks/useIsMobile";
import { useScroll } from "utils/hooks/useScroll";
import Footer from "./Footer";
import { ComponentProps } from "react";
import { Box } from "components/ui";

type Props = {
	children: React.ReactNode | React.ReactNode[];
	withPadding?: boolean;
	withFooter?: boolean;
	isDark?: boolean;
	style?: any;
	isFit?: boolean;
	scrollRef?: React.RefObject<ScrollView>;
};

const ScrollContainer = ({ children, withPadding = true, withFooter = true, isDark, style, isFit, scrollRef }: Props) => {
	const { onScroll } = useScroll();
	const isMobile = useIsMobile();

	return (
		<View style={{ flex: 1, backgroundColor: isDark ? "rgba(0, 0, 0)" : "white" }}>
			<ScrollView
				ref={scrollRef}
				scrollEventThrottle={16}
				style={{ flex: 1 }}
				onScroll={onScroll}
				contentContainerStyle={{
					paddingTop: withPadding ? (isMobile ? 0 : 200) : 0,
					flexGrow: 1,
					...style,
				}}
			>
				<View style={{ flex: 1, justifyContent: "space-between", minHeight: "100%" }}>
					<View style={{ flex: 1 }}>{children}</View>
					{withFooter && <Footer />}
				</View>
			</ScrollView>
		</View>
	);
};

export default ScrollContainer;
